import { createContext } from 'react';

/**
 * Permite mantener un solo shell visual aunque una pantalla antigua todavía
 * incluya su propio wrapper de layout.
 */
const LayoutPersistenceContext = createContext(false);

export default LayoutPersistenceContext;
